import { useState, useEffect } from "react";

//import components
import * as Options from "../utils/PropertyOptions";
import { formatDate } from '../../components/utils/Helper'

//import translation
import { useTranslation } from "react-i18next";
import "../../i18n";

//import tags
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import Select from "react-select";

//import resources
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faXmark,
    faMagnifyingGlass,
    faDoorOpen,
    faBed,
    faCrown,
    faLayerGroup,
    faBuilding,
    faRulerVertical,
    faBath,
    faSliders
} from "@fortawesome/free-solid-svg-icons";

export default function Filter({ setFilterModal, searchQueryData, setSearchQueryData, handleChangeSelect, filter, locale }) {

    //get locale
    const { t } = useTranslation();

    const [currency, setCurrency] = useState(searchQueryData?.currency ? searchQueryData.currency : 'GEL');

    function handleChangeInput(e) {
        const { name, value, type, checked } = e.target;

        // Determine if the field is an array (checkbox group)
        const isArrayField = name.endsWith("[]");
        const key = isArrayField ? name.slice(0, -2) : name;

        setSearchQueryData((prevsearchQueryData) => {
            // Copy previous data to avoid mutation
            let newData = { ...prevsearchQueryData };

            if (isArrayField) {
                // If it's an array field (checkbox group)
                const currentArray = toList(prevsearchQueryData[key]);

                if (checked) {
                    // If checked, add value to the array (ensure no duplicates)
                    newData[key] = [...new Set([...currentArray, value])];
                } else {
                    // If unchecked, remove value from the array
                    newData[key] = currentArray.filter((item) => item !== value);
                }
            } else {
                if (type === "checkbox") {
                    newData[key] = checked ? value : undefined;
                } else {
                    if (value.length > 0) {
                        newData[key] = value;
                    } else {
                        newData[key] = '';
                    }
                }
            }


            // Clean the data by removing keys with undefined, empty, or null values
            // For arrays, keep even if they are empty.
            const cleanedData = Object.fromEntries(
                Object.entries(newData).filter(([k, val]) => {
                    if (Array.isArray(val)) {
                        return true; // always keep arrays, even empty ones
                    }
                    return val !== "" && val !== undefined && val !== null;
                })
            );

            return cleanedData;
        });
    }

    useEffect(() => {
        setSearchQueryData((prevQuery) => ({
            ...prevQuery,
            currency: currency
        }))
    }, [currency])

    function handleChangeDate(name, date) {
        if (name && date) {
            setSearchQueryData((prevsearchQueryData) => ({
                ...prevsearchQueryData,
                [name]: date
            }));
        }
    }

    const hotelRoomTypeOptions = [
        { key: 'hotel_type_sgl', label: 'SGL', amountKey: 'hotel_type_sgl_amount' },
        { key: 'hotel_type_dbl', label: 'DBL', amountKey: 'hotel_type_dbl_amount' },
        { key: 'hotel_type_twin', label: 'TWIN', amountKey: 'hotel_type_twin_amount' },
        { key: 'hotel_type_trpl', label: 'TRPL', amountKey: 'hotel_type_trpl_amount' },
        { key: 'hotel_type_quad', label: 'Quad', amountKey: 'hotel_type_quad_amount' },
        { key: 'hotel_type_extra_bed', label: 'Extra Bed', amountKey: 'hotel_type_extra_bed_amount' },
        { key: 'hotel_type_queen', label: 'Queen', amountKey: 'hotel_type_queen_amount' },
        { key: 'hotel_type_king', label: 'King', amountKey: 'hotel_type_king_amount' },
        { key: 'hotel_type_studio', label: 'Studio', amountKey: 'hotel_type_studio_amount' },
        { key: 'hotel_type_connecting_room', label: 'Connecting room', amountKey: 'hotel_type_connecting_room_amount' },
        { key: 'hotel_type_adjoining_room', label: 'Adjoining room', amountKey: 'hotel_type_adjoining_room_amount' },
        { key: 'hotel_type_duplex', label: 'Duplex', amountKey: 'hotel_type_duplex_amount' },
        { key: 'hotel_type_family_room', label: 'Family room', amountKey: 'hotel_type_family_room_amount' },
        { key: 'hotel_type_accessible_room', label: 'Accessible Room / Disabled Room', amountKey: 'hotel_type_accessible_room_amount' }
    ];

    const selectedLandTypes = Array.isArray(searchQueryData?.landtype)
        ? searchQueryData.landtype
        : String(searchQueryData?.landtype || '')
            .split(',')
            .map((value) => value.trim())
            .filter(Boolean);
    const showAgriculturalLandType = selectedLandTypes.includes('agricultural');
    const showNonAgriculturalLandType = selectedLandTypes.includes('nonagricultural');

    const selectedBusinessCategories = Array.isArray(searchQueryData?.businessinvestmentcategory)
        ? searchQueryData.businessinvestmentcategory
        : String(searchQueryData?.businessinvestmentcategory || '')
            .split(',')
            .map((value) => value.trim())
            .filter(Boolean);
    const showOtherIndustry = selectedBusinessCategories.includes('other');

    const selectedFarmLandTypes = Array.isArray(searchQueryData?.landtype1)
        ? searchQueryData.landtype1
        : String(searchQueryData?.landtype1 || '')
            .split(',')
            .map((value) => value.trim())
            .filter(Boolean);
    const selectedFarmTypes = Array.isArray(searchQueryData?.farmtype)
        ? searchQueryData.farmtype
        : String(searchQueryData?.farmtype || '')
            .split(',')
            .map((value) => value.trim())
            .filter(Boolean);
    const showFarmAgriculturalType = selectedFarmLandTypes.includes('agricultural');
    const showFarmNonAgriculturalType = selectedFarmLandTypes.includes('nonagricultural');
    const showOtherFarmType = selectedFarmTypes.includes('other');

    const toList = (value) => Array.isArray(value)
        ? value
        : String(value || '')
            .split(',')
            .map((item) => item.trim())
            .filter(Boolean);

    const selectedCities = toList(searchQueryData?.city);
    const selectedDestricts = toList(searchQueryData?.destrict);
    const selectedStatuses = toList(searchQueryData?.property_status);
    const selectedTransactions = toList(searchQueryData?.transaction_type);
    const showDestrict = selectedCities.includes('tbilisi');
    const showUbani = ['tbilisi', 'batumi', 'kutaisi', 'rustavi'].some((city) => selectedCities.includes(city));
    const showRegion = selectedCities.length === 0 || selectedCities.some((city) => city !== 'tbilisi');
    const ubaniOptions = Options.ubani
        .filter((option) => selectedCities.includes(option.city))
        .filter((option) => option.city !== 'tbilisi' || selectedDestricts.length === 0 || selectedDestricts.includes(option.destrict));

    // multi select bound to searchQueryData[name]
    const renderMultiSelect = (name, options, placeholder) => (
        <div className="rfField">
            <Select
                id={name}
                value={options.filter(opt => toList(searchQueryData?.[name]).includes(opt.value))}
                name={name}
                onChange={handleChangeSelect}
                options={options}
                placeholder={placeholder}
                className="rfReactSelect"
                classNamePrefix="rf-select"
                isMulti
                hideSelectedOptions={false}
                closeMenuOnSelect={false}
            />
        </div>
    );

    // from - to number inputs: name_from / name_to
    const renderRange = (name, label, colProps = { xxl: 4 }) => (
        <Col {...colProps} className="mb-2" key={name}>
            <div className="afRangeGroup">
                <label className="afRangeLabel">{label}</label>
                <div className="afRangePair">
                    <input type='number' value={searchQueryData?.[`${name}_from`] ?? ''} name={`${name}_from`} onChange={(e) => handleChangeInput(e)} placeholder={t('from')} />
                    <span className="afRangeSep">—</span>
                    <input type='number' value={searchQueryData?.[`${name}_to`] ?? ''} name={`${name}_to`} onChange={(e) => handleChangeInput(e)} placeholder={t('to')} />
                </div>
            </div>
        </Col>
    );

    // yes / no checkboxes: [[name, label], ...]
    const renderYesCheckboxes = (fields) => (
        <div className="customFltrLabelCheck">
            {fields.map(([name, label]) => (
                <label className="customfltCheckbox" key={name}>
                    <input type="checkbox" value="yes" checked={searchQueryData?.[name] == 'yes'} onChange={(e) => handleChangeInput(e)} name={name} />
                    <span className="customFilterCheckbox"></span><strong>{label}</strong>
                </label>
            ))}
        </div>
    );

    // checkbox group saved as array: name[]
    const renderCheckboxGroup = (name, options) => (
        <div className="customFltrLabelCheck">
            {options.map((option) => (
                <label className="customfltCheckbox" key={option.value}>
                    <input type="checkbox" checked={toList(searchQueryData?.[name]).includes(option.value)} value={option.value} onChange={(e) => handleChangeInput(e)} name={`${name}[]`} />
                    <span className="customFilterCheckbox"></span><strong>{option.label}</strong>
                </label>
            ))}
        </div>
    );

    const renderSubTitle = (title) => (
        <Col xxl={12} className="mb-2 mt-3">
            <h4 className="filterInsSubTitle">{title}</h4>
        </Col>
    );

    // same values as checkbox groups in Add.js
    const communicationsOptions = [
        { value: 'electricity', label: "დენი" },
        { value: 'water', label: "წყალი" },
        { value: 'gas', label: "გაზი" },
        { value: 'sewercollector', label: "კოლექტორი-კანალიზაცია" },
        { value: 'individualurikanalizacia', label: "ინდივიდუალური კანალიზაცია" },
        { value: 'owntransformer', label: "საკუთარი ტრანსფორმატორი" },
        { value: 'lightnearland', label: "დენი ახლოს" },
        { value: 'waternearland', label: "წყალი ახლოს" },
        { value: 'gasnearland', label: "გაზი ახლოს" },
        { value: 'sewernearland', label: "კოლექტორი-კანალიზაცია ახლოს" },
    ];

    const additionaldetailsOptions = [
        { value: 'firstrow', label: "პირველი ზოლი" },
        { value: 'secondrow', label: "მეორე ზოლი" },
        { value: 'thirdrow', label: "მესამე ზოლი" },
        { value: 'easement', label: "სერვიტუტი" },
        { value: 'magalidzabva', label: "მაღალი ძაბვა" },
        { value: 'capitalfence', label: "კაპიტალური ღობე" },
        { value: 'rkinigzischixi', label: "რკინიგზის ჩიხი" },
        { value: 'mdinarispiri', label: "მდინარისპირი" },
        { value: 'bunebriviresursebi', label: "ბუნებრივი რესურსები" },
        { value: 'well', label: "ჭა" },
        { value: 'sarwyavi', label: "სარწყავი" },
        { value: 'urwyavi', label: "ურწყავი" },
        { value: 'fence', label: "ღობე" },
        { value: 'pumpsystem', label: "სატუმბი სისტემა" },
        { value: 'borehole', label: "ჭაბურღილი" },
        { value: 'dripirrigationsystem', label: "წვეთოვანი სარწყავი სისტემა" },
    ];

    const roadOptions = [
        { value: 'concrete', label: "ბეტონის" },
        { value: 'asphalted', label: "ასფალტის" },
        { value: 'pavingstone', label: "ქვაფენილი" },
        { value: 'graveled', label: "მოხრეშილი" },
        { value: 'soil', label: "გრუნტი" },
    ];

    const hotwaterOptions = [
        { value: 'centralheating', label: t('central_heating') },
        { value: 'gasheater', label: t('gas_heater') },
        { value: 'tank', label: t('tank') },
        { value: 'electricheater', label: t('electric_heater') },
        { value: 'naturalhotwater', label: t('natural_hot_water') },
        { value: 'solarheater', label: t('solar_heater2') },
    ];

    const heatingOptions = [
        { value: 'centralheating', label: t('central_heater') },
        { value: 'gasheater', label: t('gas_heat') },
        { value: 'floorheating', label: t('floor_heating') },
        { value: 'powerheater', label: t('electric_heating') },
        { value: 'chiller', label: t('chiller') },
        { value: 'solarheater', label: t('solar_heater') },
    ];

    const generalamenitiesOptions = [
        { value: 'naturalgas', label: "საკაბელო ტელევიზია" },
        { value: 'telephone', label: "ტელეფონი" },
        { value: 'internet', label: "ინტერნეტი / wifi" },
        { value: 'television', label: "ტელევიზია" },
        { value: 'alarmsystem', label: "სიგნალიზაცია" },
        { value: 'satelit', label: "სატელიტური თეფში" },
        { value: 'solarPanel', label: "მზის ენერგიის პანელი" },
        { value: 'personaltransformator', label: "საკუთარი ტრანსფორმატორი" },
        { value: 'ventilation', label: "ვენტილაცია" },
    ];

    const furnitureOptions = [
        { value: 'livingroomfurniture', label: "მისაღები ოთახის ავეჯი" },
        { value: 'softfurniture', label: "რბილი ავეჯი" },
        { value: 'kitchenfurniture', label: "სამზარეულოს ავეჯი" },
        { value: 'bedroomfurniture', label: "საძინებლის ავეჯი" },
        { value: 'summerfurniture', label: "საზაფხულო ავეჯი" },
        { value: 'officefurniture', label: "საოფისე ავეჯი" },
        { value: 'childrensfurniture', label: "საბავშვო ავეჯი" },
        { value: 'partiallyfurnished', label: "ნაწილობრივ ავეჯი" },
        { value: 'unfurnished', label: "კაბინეტის ავეჯი" },
    ];

    const technicOptions = [
        { value: 'television', label: "ტელევიზორი" },
        { value: 'refrigerator', label: "მაცივარი" },
        { value: 'microwaveoven', label: "მიკროტალღური ღუმელი" },
        { value: 'dishwasher', label: "ჭურჭლის სარეცხი მანქანა" },
        { value: 'washingmachine', label: "სარეცხი მანქანა" },
        { value: 'airconditioner', label: "კონდინციონერი" },
        { value: 'stereosystem', label: "მუსიკალური ცენტრი" },
        { value: 'rangehood', label: "გამწოვი" },
        { value: 'stove', label: "გაზქურა" },
        { value: 'vacuumcleaner', label: "მტვერსასრუტი" },
        { value: 'iron', label: "უთო" },
        { value: 'homecinema', label: "კინოთეატრი" },
        { value: 'dryer', label: "საშრობი" },
        { value: 'coffeemaker', label: "ყავის აპარატი" },
        { value: 'electrickettle', label: "ელექტრო ჩაიდანი" },
        { value: 'toaster', label: "ტოსტერი" },
        { value: 'juicer', label: "წვენსაწური" },
        { value: 'mixer', label: "მიქსერი / ბლენდერი" },
        { value: 'blender', label: "გრილი" },
        { value: 'meatgrinder', label: "ხორცის საკეპი მანქანა" },
        { value: 'computer', label: "კომპიუტერი" },
        { value: 'printerscannerxerox', label: "პრინტერი / სკანერი/ ქსეროქსი" },
        { value: 'safe', label: "სეიფი" },
        { value: 'fitnessequipment', label: "სპორტული ტრენაჟორები" },
        { value: 'generator', label: "გენერატორი" },
        { value: 'grill', label: "გრილი / მაყალი" },
    ];

    const securityOptions = [
        { value: 'alarmsystem', label: "სიგნალიზაცია" },
        { value: 'livesecurity', label: "ცოცხალი დაცვა" },
        { value: 'cctvcameras', label: "ვიდეო კამერები" },
        { value: 'entranceaccesssystem', label: "სადარბაზოს დაშვების სისტემა" },
        { value: 'gatedaccesssystem', label: "ჩაკეტილი ეზოს დაშვების სისტემა" },
        { value: 'barrier', label: "შლაგბაუმი" },
    ];

    const smarthouseOptions = [
        { value: 'controlpanels', label: "მართვის პანელები" },
        { value: 'securitysystems', label: "უსაფრთხოების სისტემები" },
        { value: 'smartcamera', label: "ჭკვიანი კამერა" },
        { value: 'curtainblind', label: "ფარდა ჟალუზი" },
        { value: 'lightingautomation', label: "განათების ავტომატიზირება" },
        { value: 'smartlock', label: "ჭკვიანი საკეტი" },
        { value: 'householdappliancecontrol', label: "საყოფაცხოვრებო ტექნიკის მართვა" },
        { value: 'audiosystem', label: "აუდიო სისტემა" },
        { value: 'smartintercom', label: "ჭკვიანი დომოფონი" },
        { value: 'smartring', label: "ჭკვიანი ზარები" },
        { value: 'smartrwatering', label: "ჭკვიანი სარწყავი სისტემა" },
        { value: 'smartdoorsensor', label: "კარის და ფანჯრის სენსორი" },
        { value: 'smartswitch', label: "ჭკვიანი ჩამრთველი" },
        { value: 'smartthermostat', label: "ჭკვიანი თერმოსტატი" },
        { value: 'smartairconditioner', label: "კონდინციონერის მართვა" },
        { value: 'smartspeaker', label: "ხმოვანი ასისტენტი" },
        { value: 'smartelectronics', label: "ჭკვიანი ელექტრო მოწყობილობები" },
    ];

    const additionaladvantagesOptions = [
        { value: 'organizedinfrastructure', label: t('organized_infrastructure') },
        { value: 'gamcholi', label: "გამჭოლი ბინა" },
        { value: 'kutxisbina', label: "კუთხის ბინა" },
        { value: 'qimwmenda', label: "ქიმწმენდა" },
        { value: 'dasufTavebaezo', label: "დასუფთავება (ეზო)" },
        { value: 'dasufTavebalifti', label: "დასუფთავება (სადარბაზო, ლიფტი)" },
        { value: 'technikurimomsaxureba', label: "ტექნიკური მომსახურება" },
        { value: 'gamwvanebismovla', label: "გამწვანების მოვლა" },
        { value: 'panoramicview', label: t('panoramic_view') },
        { value: 'cityview', label: t('city_view') },
        { value: 'seaview', label: t('seaview') },
        { value: 'mountainview', label: t('mountainview') },
        { value: 'riverview', label: t('riverview') },
        { value: 'lakeview', label: t('lakeview') },
        { value: 'courtyardview', label: t('courtyardview') },
        { value: 'bright', label: t('bright') },
        { value: 'stainedglasswindowdoor', label: t('stainedglasswindowdoor') },
        { value: 'landscaping', label: t('landscaping') },
        { value: 'childrenspace', label: t('childrenspace') },
        { value: 'sportsfield', label: t('sportsfield') },
        { value: 'padelfield', label: "პადელის მოედანი" },
        { value: 'bikeroad', label: "ველობილიკი" },
        { value: 'concierge', label: t('concierge') },
        { value: 'coworkingspace', label: t('coworkingspace') },
        { value: 'businesslobby', label: t('businesslobby') },
        { value: 'cafeteria', label: t('cafeteria') },
        { value: 'restaurant', label: t('restaurant') },
        { value: 'restaurantonterace', label: "რესტორანი ტერასაზე" },
        { value: 'conferencehall', label: t('conferencehall') },
        { value: 'eventhall', label: t('eventhall') },
        { value: 'commercialspace', label: t('commercialspace') },
        { value: 'residentiallobby', label: t('residentiallobby') },
        { value: 'freewifi', label: t('freewifi') },
        { value: 'laundry', label: t('laundry') },
        { value: 'spacenter', label: t('spacenter') },
        { value: 'sauna', label: t('sauna') },
        { value: 'fitnessroom', label: t('fitnessroom') },
        { value: 'tenniscourts', label: t('tenniscourts') },
        { value: 'golfcourse', label: t('golfcourse') },
        { value: 'multifunctional', label: t('multifunctional') },
        { value: 'energyefficient', label: t('energyefficient') },
        { value: 'modernarchitecture', label: t('modernarchitecture') },
        { value: 'glazedbalconies', label: t('glazedbalconies') },
        { value: 'jacuzzi', label: t('jacuzzi') },
        { value: 'showercabinplusbathtub', label: t('showercabinplusbathtub') },
        { value: 'electriccarservice', label: "ელექტრომობილით მომსახურება" },
        { value: 'nulovanizoli', label: "ნულოვანი ზოლი" },
        { value: '360view', label: "360° ხედი" },
        { value: 'goodlocation', label: "კარგი ლოკაცია" },
        { value: 'completedbuilding', label: "ჩაბარებული კორპუსი" },
        { value: 'aclasslift', label: "A კლასის ლიფტი" },
        { value: 'hoteltypeapartment', label: "სასტუმროს ტიპის აპარტამენტი" },
        { value: 'shoppingcenter', label: "სავაჭრო ცენტრი" },
        { value: 'quietness', label: "სიმყუდროვე" },
        { value: 'panoramicpool', label: "პანორამული აუზი" },
        { value: 'investmentapartments', label: "საინვესტიციო ბინები" },
        { value: 'childrenspool', label: "საბავშვო აუზი" },
        { value: 'olympicpool', label: "ოლიმპიური აუზი" },
        { value: 'aquapark', label: "აკვაპარკი" },
        { value: 'privatebeach', label: "კერძო სანაპირო ზოლი" },
        { value: 'seismically_safe', label: "სეისმურად უსაფრთხო" },
        { value: 'sound_insulation', label: "ხმის იზოლაცია" },
        { value: 'modern_construction_material', label: "თანამედროვე სამშენებლო მასალა" },
        { value: 'dry_sauna', label: "მშრალი საუნა" },
        { value: 'turkish_sauna', label: "თურქული საუნა" },
        { value: 'finnish_sauna', label: "ფინური საუნა" },
        { value: 'shower', label: "საშხაპე" },
        { value: 'artificial_waterfall', label: "ხელოვნური ჩანჩქერი" },
        { value: 'panoramic_elevator', label: "პანორამული ლიფტი" },
        { value: 'electric_car_charger', label: "ელექტრომობილის დამტენი" },
        { value: 'recreation_area', label: "რეკრეაციული ზონა" },
        { value: 'car_wash', label: "ავტომობილების რეცხვა" },
        { value: 'beach_club', label: "ბიჩ ქლაბი" },
        { value: 'free_layout', label: "თავისუფალი გეგმარება" },
        { value: 'helipad', label: "ვერტმფრენის დასაჯდომი" },
    ];

    const additionalsecurityOptions = [
        { value: 'evacuationstaircase', label: "საევაკუაციო კიბე" },
        { value: 'firesafetyssystem', label: "ხანძრის საწინააღმდეგო სისტემა" },
        { value: 'codetector', label: "CO დეტექტორი" },
        { value: 'smokedetector', label: "კვამლის დეტექტორი" },
        { value: 'fireextinguisher', label: "ცეცხლმაქრი" },
        { value: 'water_reservoir', label: "წყლის რეზერვუარი" },
    ];

    const allowedOptions = [
        { value: 'eventhosting', label: "წვეულების გამართვა" },
        { value: 'pets', label: "შინაური ცხოველები" },
        { value: 'smoking', label: "მოწევა" },
    ];

    const facade1Options = [
        { value: 'galesili', label: "გალესილი" },
        { value: 'facadeadded1', label: "მიუნხენი" },
        { value: 'facadeadded2', label: "ესპანკა" },
        { value: 'facadeadded3', label: "XPS" },
        { value: 'facadeadded4', label: "ბრიზგი" },
        { value: 'facadeadded5', label: "მარმარილო" },
        { value: 'facadeadded6', label: "ტუფი" },
        { value: 'facadeadded7', label: "გიბსოკარდონი" },
        { value: 'facadePanel', label: "ფასადის პანელი" },
        { value: 'aguri', label: "აგური" },
        { value: 'traventili', label: "ტრავენტილი" },
        { value: 'xisPaneli', label: "ხის პანელი" },
        { value: 'hplPanel', label: "HPL პანელი" },
        { value: 'combined', label: "კომბინირებული" },
        { value: 'minapacket', label: "მინაპაკეტი" },
        { value: 'facadestone', label: "ფასადის ქვა" },
        { value: 'quartz', label: "კვარცი" },
        { value: 'onyx', label: "ონიქსი" },
        { value: 'ceramic', label: "კერამოგრანიტი" },
        { value: 'facade_block', label: "ფასადის ბლოკი" },
        { value: 'thermally_treated_wood', label: "თერმულად დამუშავებული ხე" },
        { value: 'fiber_cement_panels', label: "ფიბროცემენტის პანელი" },
        { value: 'alucobond_ventilated_facade', label: "ალუკობონდის ფასადი" },
        { value: 'exterior_facade_decor', label: "გარე ფასადის დეკორი" },
        { value: 'steel_sheet', label: "ფოლადის ფირფიტა" },
        { value: 'plaster', label: "თაბაშირი" },
    ];

    const buildingmaterialOptions = [
        { value: 'block', label: t('block') },
        { value: 'brick', label: t('brick') },
        { value: 'stone', label: t('stone') },
        { value: 'wood', label: t('wood') },
        { value: 'pumiceblock', label: t('pumiceblock') },
        { value: 'reinforcedconcrete', label: t('reinforcedconcrete') },
        { value: 'sendvichPanel', label: t('sendvichPanel') },
        { value: 'minaPaket', label: t('minaPaket') },
        { value: 'combined', label: t('combined') },
        { value: 'concrete_block', label: "ბეტონის ბლოკი" },
        { value: 'polytech_block', label: "პოლიტექ ბლოკი" },
        { value: 'air_block', label: "აირ ბლოკი" },
        { value: 'aluminum_structure', label: "ალუმინის კონსტრუქცია" },
        { value: 'zinc', label: "სინკარი" },
    ];

    const doorandwindowOptions = [
        { value: 'doorwindow1', label: "ვიტრაჟული" },
        { value: 'doorwindow2', label: "სლაიდი" },
        { value: 'doorwindow3', label: "მინაპაკეტი" },
        { value: 'doorwindow4', label: "ახალი ხე" },
        { value: 'doorwindow5', label: "ძველი ხე" },
        { value: 'doorwindow6', label: "მეტალო პლასტმასი" },
        { value: 'doorwindow7', label: "ალუმინი" },
        { value: 'doorwindow8', label: "კომბინირებული" },
        { value: 'doorwindow9', label: "მასიური ხე" },
    ];

    const overlapOptions = [
        { value: 'flat', label: "ბრტყელი" },
        { value: 'conical', label: "კონუსებური" },
        { value: 'tinroofing', label: "თუნუქის გადახურვა" },
        { value: 'corrugatedroofing', label: "ტოლით გადახურვა" },
        { value: 'tileroof', label: "კრამიტის სახურავი" },
        { value: 'sendvich', label: "სენდვიჩ პანელი" },
        { value: 'beton', label: "ბეტონი" },
        { value: 'tagovani', label: "თაღოვანი" },
        { value: 'piramid', label: "პირამიდული" },
        { value: 'valmur', label: "ვალმური" },
        { value: 'gambler', label: "გამბლერის სახურავი" },
        { value: 'mansard', label: "მანსარდული" },
    ];

    const overlapmaterialOptions = [
        { value: 'overlapmaterial1', label: "ტოლი" },
        { value: 'overlapmaterial2', label: "ბიტუმ-პოლიმერი" },
        { value: 'overlapmaterial3', label: "ბეტონი" },
        { value: 'overlapmaterial4', label: "სენდვიჩპანელი" },
        { value: 'overlapmaterial5', label: "კრამიტი" },
        { value: 'overlapmaterial6', label: "შინგლი (რბილი კრამიტი)" },
        { value: 'overlapmaterial7', label: "შიფერი" },
        { value: 'overlapmaterial8', label: "ევროშიფერი" },
        { value: 'overlapmaterial9', label: "თუნუქის" },
        { value: 'overlapmaterial10', label: "მეტალოკრამიტი" },
        { value: 'overlapmaterial11', label: "პოლიკარბონატი" },
        { value: 'overlapmaterial12', label: "მინის სახურავი" },
        { value: 'overlapmaterial13', label: "მინა პაკეტი" },
        { value: 'overlapmaterial14', label: "ხის სახურავი" },
        { value: 'overlapmaterial15', label: "ქვის სახურავი" },
    ];

    const fundamentOptions = [
        { value: 'lent', label: "ლენტოვანი" },
        { value: 'khiminji', label: "ხიმინჯი" },
        { value: 'balishovani', label: "ბალიშოვანი (ფილა)" },
        { value: 'dotted', label: "წერტილოვანი" },
        { value: 'combined', label: "კომბინიებული" },
        { value: 'no_foundation', label: "საძირკვლის არმქონე" },
    ];

    return (
        <>
            <div className="addonFilterBox">

                <div className="addonFilterHead">
                    <h4>{t('detailed_filter')}</h4>
                    <span onClick={() => setFilterModal(false)}>
                        <FontAwesomeIcon icon={faXmark} />
                    </span>
                </div>

                <div className="addonFilterContent">

                    <Row>

                        <Col xxl={12} className="mb-2">
                            <h4 className="filterInsTitle">{t('general_information')}</h4>
                        </Col>

                        <Col xxl={4} className="mb-2">
                            <div className="afRangeGroup">
                                <label className="afRangeLabel"><FontAwesomeIcon icon={faDoorOpen} /> {t('room_amount')}</label>
                                <div className="afRangePair">
                                    <input type='number' value={searchQueryData?.rooms_from} name='rooms_from' onChange={(e) => handleChangeInput(e)} placeholder={t('from')} />
                                    <span className="afRangeSep">—</span>
                                    <input type='number' value={searchQueryData?.rooms_to} name='rooms_to' onChange={(e) => handleChangeInput(e)} placeholder={t('to')} />
                                </div>
                            </div>
                        </Col>

                        <Col xxl={4} className="mb-2">
                            <div className="afRangeGroup">
                                <label className="afRangeLabel"><FontAwesomeIcon icon={faBed} /> {t('livingroom_amount')}</label>
                                <div className="afRangePair">
                                    <input type='number' value={searchQueryData?.bedrooms_from} name='bedrooms_from' onChange={(e) => handleChangeInput(e)} placeholder={t('from')} />
                                    <span className="afRangeSep">—</span>
                                    <input type='number' value={searchQueryData?.bedrooms_to} name='bedrooms_to' onChange={(e) => handleChangeInput(e)} placeholder={t('to')} />
                                </div>
                            </div>
                        </Col>

                        <Col xxl={4} className="mb-2">
                            <div className="afRangeGroup">
                                <label className="afRangeLabel"><FontAwesomeIcon icon={faCrown} /> {t('masterroom_amount')}</label>
                                <div className="afRangePair">
                                    <input type='number' value={searchQueryData?.masterbedrooms_from} name='masterbedrooms_from' onChange={(e) => handleChangeInput(e)} placeholder={t('from')} />
                                    <span className="afRangeSep">—</span>
                                    <input type='number' value={searchQueryData?.masterbedrooms_to} name='masterbedrooms_to' onChange={(e) => handleChangeInput(e)} placeholder={t('to')} />
                                </div>
                            </div>
                        </Col>

                        <Col xxl={4} className="mb-2">
                            <div className="afRangeGroup">
                                <label className="afRangeLabel"><FontAwesomeIcon icon={faLayerGroup} /> {t('floor')}</label>
                                <div className="afRangePair">
                                    <input type='number' value={searchQueryData?.floor_from} name='floor_from' onChange={(e) => handleChangeInput(e)} placeholder={t('from')} />
                                    <span className="afRangeSep">—</span>
                                    <input type='number' value={searchQueryData?.floor_to} name='floor_to' onChange={(e) => handleChangeInput(e)} placeholder={t('to')} />
                                </div>
                            </div>
                        </Col>

                        <Col xxl={4} className="mb-2">
                            <div className="afRangeGroup">
                                <label className="afRangeLabel"><FontAwesomeIcon icon={faBuilding} /> {t('floor_amount')}</label>
                                <div className="afRangePair">
                                    <input type='number' value={searchQueryData?.allfloor_from} name='allfloor_from' onChange={(e) => handleChangeInput(e)} placeholder={t('from')} />
                                    <span className="afRangeSep">—</span>
                                    <input type='number' value={searchQueryData?.allfloor_to} name='allfloor_to' onChange={(e) => handleChangeInput(e)} placeholder={t('to')} />
                                </div>
                            </div>
                        </Col>
                        
                        {/* დამატებული */}
                        <Col xxl={4} className="mb-2">
                            <div className="afRangeGroup">
                                <label className="afRangeLabel"><FontAwesomeIcon icon={faRulerVertical} /> ჭერის სიმაღლე (სმ)</label>
                                <div className="afRangePair">
                                    <input type='number' value={searchQueryData?.ceilingHeight_from} name='ceilingHeight_from' onChange={(e) => handleChangeInput(e)} placeholder={t('from')} />
                                    <span className="afRangeSep">—</span>
                                    <input type='number' value={searchQueryData?.ceilingHeight_to} name='ceilingHeight_to' onChange={(e) => handleChangeInput(e)} placeholder={t('to')} />
                                </div>
                            </div>
                        </Col>
                        {/* დამატებული */}

                        {renderRange('land_area', <>მიწის ნაკვეთის ფართი ({t('m')}<sup>2</sup>)</>)}
                        {renderRange('entranceCount', 'სადარბაზოს რაოდ.')}

                        {renderSubTitle(t('location'))}

                        {showDestrict ?
                        <Col xxl={4} className="mb-2">
                            <label className="filterLbl">{t('district')}</label>
                            {renderMultiSelect('destrict', Options.destrictOptions, t('district'))}
                        </Col>
                        : ''}

                        {showUbani ?
                        <Col xxl={4} className="mb-2">
                            <label className="filterLbl">{t('ubani')}</label>
                            {renderMultiSelect('ubani', ubaniOptions, t('ubani'))}
                        </Col>
                        : ''}

                        {showRegion ?
                        <>
                            <Col xxl={4} className="mb-2">
                                <label className="filterLbl">{t('region')}</label>
                                {renderMultiSelect('region', Options.districtOptions, t('region'))}
                            </Col>
                            <Col xxl={4} className="mb-2">
                                <label className="filterLbl">{t('municipality')}</label>
                                {renderMultiSelect('municipality', Options.municipalOptions, t('municipality'))}
                            </Col>
                        </>
                        : ''}

                        <Col xxl={12} className="mb-2 mt-3">
                            <h4 className="filterInsSubTitle">{t('property_status')}</h4>
                        </Col>

                        <Col xxl={12} className="mb-2">
                            <div className="rfField afSelectWithIcon">
                                <span className="afSelectLeadIcon">
                                    <FontAwesomeIcon icon={faSliders} />
                                </span>
                                <Select
                                    id="property_status"
                                    value={Options.propertyStatusOptions.filter(opt =>
                                        (searchQueryData?.property_status || '').includes(opt.value))}
                                    name="property_status"
                                    onChange={handleChangeSelect}
                                    options={Options.propertyStatusOptions}
                                    placeholder={t('choose_property_status')}
                                    className="rfReactSelect"
                                    classNamePrefix="rf-select"
                                    isMulti
                                    hideSelectedOptions={false}
                                    closeMenuOnSelect={false}
                                />
                            </div>
                        </Col>
                        
                        {renderSubTitle('პროექტი')}

                        <Col xxl={4} className="mb-2">
                            <label className="filterLbl">{t('project_class')}</label>
                            {renderMultiSelect('class', Options.propertyProjectClassOptions, t('choose_project_class'))}
                        </Col>

                        <Col xxl={4} className="mb-2">
                            <label className="filterLbl">აშენების თარიღი</label>
                            {renderMultiSelect('build_date', Options.buildyears, t('type_build_date'))}
                        </Col>

                        <Col xxl={4} className="mb-2">
                            <label className="filterLbl">პროექტის ექსტერიერის სტილი</label>
                            {renderMultiSelect('property_project_exterrior_style', Options.propertyProjectExterriorStyleOptions, 'პროექტის ექსტერიერის სტილი')}
                        </Col>

                        <Col xxl={4} className="mb-2">
                            <label className="filterLbl">პროექტის ინტერიერის სტილი</label>
                            {renderMultiSelect('property_project_style', Options.propertyProjectInteriorStyleOptions, 'პროექტის ინტერიერის სტილი')}
                        </Col>

                        <Col xxl={12} className="mb-2">
                            {renderYesCheckboxes([
                                ['disabledaccessible', 'შშმ ადაპტირებული'],
                                ['finished_project', 'დასრულებული პროექტი'],
                                ['customized_payment', 'გადახდის მორგებული გრაფიკი'],
                                ['financed_by_bank', 'დაფინანსებულია ბანკის მიერ'],
                                ['investment_apartments', 'საინვესტიციო ბინები'],
                                ['residential_apartments', 'საცხოვრებელი ბინები'],
                                ['complete_renovation', 'ბინები სრული რემონტით'],
                                ['five_star_hotel_standard', '5 ვარკვლავიანი სასტუმროს სტანდარტით'],
                                ['property_management_service', 'ქონების მართვის სერვისი'],
                            ])}
                        </Col>

                        {selectedStatuses.includes('new') || selectedStatuses.includes('underconstruction') ?
                            renderRange('roi_percent', 'ამონაგები პროცენტი (ROI)')
                        : ''}

                        {selectedStatuses.includes('underconstruction') ?
                        <>
                            {[
                                ['block_amount', 'კორპუსის რაოდენობა'],
                                ['villa_amount', 'კ/სახლი, ვილა, თაუნჰაუსი, კოტეჯის რაოდენობა'],
                                ['land_size', 'მიწის ფართი'],
                                ['apartment_amount', 'ბინების რაოდენობა'],
                                ['studio_amount', 'სტუდიოს რაოდენობა'],
                                ['one_bedroom_amount', '1 საძინ. რაოდენობა'],
                                ['two_bedroom_amount', '2 საძინ. რაოდენობა'],
                                ['three_bedroom_amount', '3 საძინ. რაოდენობა'],
                                ['four_bedroom_amount', '4 საძინ. რაოდენობა'],
                                ['five_bedroom_amount', '5 საძინ. რაოდენობა'],
                                ['fiveplus_bedroom_amount', '5 + საძინ. რაოდენობა'],
                                ['duplex_amount', 'დუპლექსის რაოდენობა'],
                                ['terrace_amount', 'ტერასიანი ბინების რაოდენობა'],
                                ['commercial_area_count', 'კომერციული ფართის რაოდენობა'],
                                ['office_area_count', 'საოფისე ფართის რაოდენობა'],
                                ['parking_amount', 'პარკინგის საერთო რაოდენობა'],
                                ['installment_months', 'უპრ. განვადების თვეების რაოდენობა'],
                                ['minimal_percent', 'მინიმალური შესატანი პროცენტი'],
                            ].map(([name, label]) => renderRange(name, label))}
                        </>
                        : ''}

                        {/* დამატებული */}
                        <Col xxl={12} className="mb-2 mt-3">
                            <h4 className="filterInsSubTitle">მეტრო სადგურთან ახლოს</h4>
                        </Col>

                        <Col xxl={12} className="mb-2">
                            <div className="rfField">
                                <Select
                                    id="metrosstation_options"
                                    value={Options.metroStationOptions.filter(opt =>
                                        (searchQueryData?.metrosstation_options || '').includes(opt.value))}
                                    name="metrosstation_options"
                                    onChange={handleChangeSelect}
                                    options={Options.metroStationOptions}
                                    placeholder="აირჩიეთ მეტროს სადგური"
                                    className="rfReactSelect"
                                    classNamePrefix="rf-select"
                                    isMulti
                                    hideSelectedOptions={false}
                                    closeMenuOnSelect={false}
                                />
                            </div>
                        </Col>
                        {/* დამატებული */}

                        <Col xxl={12} className="mb-2 mt-3">
                            <h4 className="filterInsSubTitle">პარკინგი</h4>
                        </Col>

                        <Col xxl={12} className="mb-2">
                            <div className="customFltrLabelCheck">
                                <label className="customfltCheckbox">
                                    <input type="checkbox" value="yes" checked={searchQueryData?.yardparking == 'yes'} onChange={(e) => handleChangeInput(e)} name="yardparking" /><span className="customFilterCheckbox"></span><strong>{t('yadrking')}</strong>
                                </label>
                                <label className="customfltCheckbox">
                                    <input type="checkbox" value="yes" checked={searchQueryData?.undergroundparking == 'yes'} onChange={(e) => handleChangeInput(e)} name="undergroundparking" /><span className="customFilterCheckbox"></span><strong>{t('underground_parking')}</strong>
                                </label>
                                <label className="customfltCheckbox">
                                    <input type="checkbox" value="yes" checked={searchQueryData?.parkingspace == 'yes'} onChange={(e) => handleChangeInput(e)} name="parkingspace" /><span className="customFilterCheckbox"></span><strong>{t('parking_place')}</strong>
                                </label>
                                <label className="customfltCheckbox">
                                    <input type="checkbox" value="yes" checked={searchQueryData?.paidparking == 'yes'} onChange={(e) => handleChangeInput(e)} name="paidparking" /><span className="customFilterCheckbox"></span><strong>ფასიანი პარკინგი</strong>
                                </label>
                                <label className="customfltCheckbox">
                                    <input type="checkbox" value="yes" checked={searchQueryData?.garage == 'yes'} onChange={(e) => handleChangeInput(e)} name="garage" /><span className="customFilterCheckbox"></span><strong>ავტოფარეხი</strong>
                                </label>
                            </div>
                        </Col>

                        <Col xxl={12} className="mb-2 mt-3">
                            <h4 className="filterInsSubTitle">{t('bathrooms')}</h4>
                        </Col>

                        <Col xxl={4} className="mb-2">
                            <div className="afRangeGroup">
                                <label className="afRangeLabel"><FontAwesomeIcon icon={faBath} /> {t('bathrooms')}</label>
                                <div className="afRangePair">
                                    <input type='number' value={searchQueryData?.bathrooms_from} name='bathrooms_from' onChange={(e) => handleChangeInput(e)} placeholder={t('from')} />
                                    <span className="afRangeSep">—</span>
                                    <input type='number' value={searchQueryData?.bathrooms_to} name='bathrooms_to' onChange={(e) => handleChangeInput(e)} placeholder={t('to')} />
                                </div>
                            </div>
                        </Col>
                        
                        {/* დამატებული */}
                        <Col xxl={8} className="mb-2">
                            <div className="customFltrLabelCheck customFltrCstm">
                                <label className="customfltCheckbox">
                                    <input type="checkbox" value="yes" checked={searchQueryData?.commonbathroom == 'yes'} onChange={(e) => handleChangeInput(e)} name="commonbathroom" /><span className="customFilterCheckbox"></span><strong>საერთო სველი წერტილი</strong>
                                </label>
                            </div>
                        </Col>
                        {/* დამატებული */}











                        {/* სახლის დეტალები */}
                        {searchQueryData?.property_type?.includes('house') || searchQueryData?.property_type?.includes('cottage') || searchQueryData?.property_type?.includes('townhouse') ?
                        <>
                            <Col xxl={12} className="addonSectionBorderTop" />

                            <Col xxl={12} className="mb-2 mt-2">
                                <h4 className="filterInsSubTitle">კერძო სახლი, ვილა, აგარაკი, კოტეჯი, თაუნ ჰაუსის დეტალები</h4>
                            </Col>

                            <Col xxl={12} className="mb-2">
                                <div className="customFltrLabelCheck">
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.fence == 'yes'} onChange={(e) => handleChangeInput(e)} name="fence" />
                                        <span className="customFilterCheckbox"></span><strong>ღობე</strong>
                                    </label>
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.capitalfence == 'yes'} onChange={(e) => handleChangeInput(e)} name="capitalfence" />
                                        <span className="customFilterCheckbox"></span><strong>კაპიტალური ღობე</strong>
                                    </label>
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.vine == 'yes'} onChange={(e) => handleChangeInput(e)} name="vine" />
                                        <span className="customFilterCheckbox"></span><strong>ვაზი</strong>
                                    </label>
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.fruit == 'yes'} onChange={(e) => handleChangeInput(e)} name="fruit" />
                                        <span className="customFilterCheckbox"></span><strong>ხეხილი</strong>
                                    </label>
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.citrus == 'yes'} onChange={(e) => handleChangeInput(e)} name="citrus" />
                                        <span className="customFilterCheckbox"></span><strong>ციტრუსი</strong>
                                    </label>
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.leafy == 'yes'} onChange={(e) => handleChangeInput(e)} name="leafy" />
                                        <span className="customFilterCheckbox"></span><strong>ფოთლოვანი</strong>
                                    </label>
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.coniferous == 'yes'} onChange={(e) => handleChangeInput(e)} name="coniferous" />
                                        <span className="customFilterCheckbox"></span><strong>წიწვოვანი</strong>
                                    </label>
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.goodrelief == 'yes'} onChange={(e) => handleChangeInput(e)} name="goodrelief" />
                                        <span className="customFilterCheckbox"></span><strong>კარგი რელიეფი</strong>
                                    </label>
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.relieful_land == 'yes'} onChange={(e) => handleChangeInput(e)} name="relieful_land" />
                                        <span className="customFilterCheckbox"></span><strong>რელიეფური მიწა</strong>
                                    </label>
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.highland_status == 'yes'} onChange={(e) => handleChangeInput(e)} name="highland_status" />
                                        <span className="customFilterCheckbox"></span><strong>მაღალმთიანი მიწის სტატუსი</strong>
                                    </label>
                                </div>
                            </Col>

                            <Col xxl={12} className="mb-2">
                                {renderYesCheckboxes([
                                    ['non_rural', 'არასასოფლო მიწა'],
                                    ['rural', 'სასოფლო მიწა'],
                                    ['flowering', 'ყვავილოვანი მცენარე'],
                                    ['perennial', 'მრავალწლოვანი მცენარე'],
                                    ['shrubs_grasses', 'ბუჩქები, ბალახოვანი მცენარე'],
                                    ['decorative', 'დეკორატიული მცენარე'],
                                    ['palm', 'პალმა'],
                                    ['nut', 'კაკალი/თხილი'],
                                    ['tea', 'ჩაი'],
                                    ['eucalyptus', 'ევკალიპტი'],
                                    ['bamboo', 'ბამბუკი'],
                                    ['greenhouse', 'სათბური'],
                                    ['irrigation_system', 'სარწყავი სისტემა'],
                                    ['shared_wet_area', 'საერთო სველი წერტილი'],
                                    ['external_wet_area', 'გარე სველი წერტილი'],
                                ])}
                            </Col>

                            <Col xxl={12} className="addonSectionBorderBottom" />
                        </>
                        : ''}



                        {/* საოფისე ფართის დეტალები */}
                        {searchQueryData?.property_type?.includes('comercialoffice') ?
                        <>
                            <Col xxl={12} className="addonSectionBorderTop" />

                            <Col xxl={12} className="mb-2 mt-2">
                                <h4 className="filterInsSubTitle">კომერციული საოფისე ფართის დეტალები</h4>
                            </Col>

                            <Col xxl={12} className="mb-2">
                                <div className="rfField">
                                    <Select
                                        id="typeofspace"
                                        value={Options.areaTypes.filter(opt =>
                                            (searchQueryData?.typeofspace || '').includes(opt.value))}
                                        name="typeofspace"
                                        onChange={handleChangeSelect}
                                        options={Options.areaTypes}
                                        placeholder={t('choosea_rea_type')}
                                        className="rfReactSelect"
                                        classNamePrefix="rf-select"
                                        isMulti
                                        hideSelectedOptions={false}
                                        closeMenuOnSelect={false}
                                    />
                                </div>
                            </Col>

                            <Col xxl={12} className="mb-3">
                                <div className="customFltrLabelCheck">
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.separatebuilding == 'yes'} onChange={(e) => handleChangeInput(e)} name="separatebuilding" />
                                        <span className="customFilterCheckbox"></span><strong>ცალკე მდგარი შენობა</strong>
                                    </label>
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.partofbuilding == 'yes'} onChange={(e) => handleChangeInput(e)} name="partofbuilding" />
                                        <span className="customFilterCheckbox"></span><strong>შენობის ნაწილი</strong>
                                    </label>
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.railroad == 'yes'} onChange={(e) => handleChangeInput(e)} name="railroad" />
                                        <span className="customFilterCheckbox"></span><strong>გზისპირი</strong>
                                    </label>
                                    {/* <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.crowdedplace == 'yes'} onChange={(e) => handleChangeInput(e)} name="crowdedplace" />
                                        <span className="customFilterCheckbox"></span><strong>ხალხმრავალი ადგილი</strong>
                                    </label> */}
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.showcase == 'yes'} onChange={(e) => handleChangeInput(e)} name="showcase" />
                                        <span className="customFilterCheckbox"></span><strong>ვიტრინა</strong>
                                    </label>
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.facade == 'yes'} onChange={(e) => handleChangeInput(e)} name="facade" />
                                        <span className="customFilterCheckbox"></span><strong>ფასადი</strong>
                                    </label>
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.hall2 == 'yes'} onChange={(e) => handleChangeInput(e)} name="hall2" />
                                        <span className="customFilterCheckbox"></span><strong>დარბაზი</strong>
                                    </label>
                                </div>
                            </Col>

                            {searchQueryData?.showcase == 'yes' ? renderRange('showcaselength', 'ვიტრინის სიგრძე (სმ)') : ''}
                            {searchQueryData?.facade == 'yes' ? renderRange('facadelength', 'ფასადის სიგრძე (სმ)') : ''}
                            {searchQueryData?.hall2 == 'yes' ? renderRange('hall2area', <>დარბაზის ფართი ({t('m')}<sup>2</sup>)</>) : ''}

                            <Col xxl={12} className="addonSectionBorderBottom" />

                        </>
                        : ''}

                        {/* სასტუმროს დეტალები */}
                        {searchQueryData?.property_type?.includes('hotel') ?
                        <>
                            <Col xxl={12} className="addonSectionBorderTop" />

                            <Col xxl={12} className="mb-2 mt-2">
                                <h4 className="filterInsSubTitle">{t('hotel_details')}</h4>
                            </Col>

                            <Col xxl={4} md={4} className="mb-2">
                                <div className="afRangeGroup">
                                    <label className="afRangeLabel">ვარსკვლავების რაოდენობა</label>
                                    <div className="d-flex gap-2">
                                        <div className="rfField w-100">
                                            <Select
                                                id="numberofstars"
                                                value={Options.hotelStars.filter(opt =>
                                                    (searchQueryData?.numberofstars || []).includes(opt.value))}
                                                name="numberofstars"
                                                onChange={handleChangeSelect}
                                                options={Options.hotelStars}
                                                placeholder={t('from')}
                                                className="rfReactSelect"
                                                classNamePrefix="rf-select"
                                                isMulti
                                                hideSelectedOptions={false}
                                                closeMenuOnSelect={false}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Col>

                            <Col xxl={4} md={4} className="mb-2">
                                <div className="afRangeGroup">
                                    <label className="afRangeLabel">{t('rooms_amount')}</label>
                                    <div className="afRangePair">
                                        <input type='number' value={searchQueryData?.roomamount_from} onChange={(e) => handleChangeInput(e)} name='roomamount_from' placeholder={t('from')} />
                                        <span className="afRangeSep">—</span>
                                        <input type='number' value={searchQueryData?.roomamount_to} onChange={(e) => handleChangeInput(e)} name='roomamount_to' placeholder={t('to')} />
                                    </div>
                                </div>
                            </Col>

                            <Col xxl={4} md={4} className="mb-2">
                                <div className="afRangeGroup">
                                    <label className="afRangeLabel">{t('lux_amount')}</label>
                                    <div className="afRangePair">
                                        <input type='number' value={searchQueryData?.luxamount_from} onChange={(e) => handleChangeInput(e)} name='luxamount_from' placeholder={t('from')} />
                                        <span className="afRangeSep">—</span>
                                        <input type='number' value={searchQueryData?.luxamount_to} onChange={(e) => handleChangeInput(e)} name='luxamount_to' placeholder={t('to')} />
                                    </div>
                                </div>
                            </Col>

                            <Col xxl={12} className="mb-2">
                                <div className="customFltrLabelCheck">
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.glamping == 'yes'} onChange={(e) => handleChangeInput(e)} name="glamping" />
                                        <span className="customFilterCheckbox"></span><strong>გლემფინგი</strong>
                                    </label>
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.familyhotel == 'yes'} onChange={(e) => handleChangeInput(e)} name="familyhotel" />
                                        <span className="customFilterCheckbox"></span><strong>{t('familyhotel')}</strong>
                                    </label>
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.hostel == 'yes'} onChange={(e) => handleChangeInput(e)} name="hostel" />
                                        <span className="customFilterCheckbox"></span><strong>{t('hostel')}</strong>
                                    </label>
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.hotel_type_cottage == 'yes'} onChange={(e) => handleChangeInput(e)} name="hotel_type_cottage" />
                                        <span className="customFilterCheckbox"></span><strong>სასტუმროს ტიპის კოტეჯი</strong>
                                    </label>
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.hotel_type_apartment == 'yes'} onChange={(e) => handleChangeInput(e)} name="hotel_type_apartment" />
                                        <span className="customFilterCheckbox"></span><strong>სასტუმროს ტიპის აპარტამენტი</strong>
                                    </label>
                                </div>
                            </Col>

                            <Col xxl={12} className="mb-2">
                                {renderYesCheckboxes([
                                    ['boat', 'კატერი'],
                                    ['scooter', 'სკუტერი'],
                                    ['quadrocycle', 'კვადროციკლი'],
                                    ['horses', 'ცხენები'],
                                ])}
                            </Col>

                            {searchQueryData?.glamping == 'yes' ?
                            <>
                                <Col xxl={4} className="mb-3">
                                    <div className="form-group filterFormGroupInput">
                                        <label htmlFor='area'>გლემფინგის რაოდენობა</label>
                                        <input type='number' value={searchQueryData?.glampingamount_from} onChange={(e) => handleChangeInput(e)} name='glampingamount_from' placeholder={t('from')} />
                                    </div>
                                </Col>

                                <Col xxl={4} className="mb-3">
                                    <div className="form-group filterFormGroupInput">
                                        <label htmlFor='area'>&nbsp;</label>
                                        <input type='number' value={searchQueryData?.glampingamount_to} onChange={(e) => handleChangeInput(e)} name='glampingamount_to' placeholder={t('to')} />
                                    </div>
                                </Col>
                            </>
                            : ''}

                            <Col xxl={12} className="mb-2 mt-2">
                                <h4 className="filterInsSubTitle">ოთახის კატეგორიის ტიპები</h4>
                            </Col>

                            <Col xxl={12} className="mb-2">
                                <div className="customFltrLabelCheck">
                                    {hotelRoomTypeOptions.map((roomType) => (
                                        <label className="customfltCheckbox" key={roomType.key}>
                                            <input type="checkbox" value="yes" checked={searchQueryData?.[roomType.key] == 'yes'} onChange={(e) => handleChangeInput(e)} name={roomType.key} />
                                            <span className="customFilterCheckbox"></span><strong>{roomType.label}</strong>
                                        </label>
                                    ))}
                                </div>
                            </Col>

                            {hotelRoomTypeOptions
                                .filter((roomType) => searchQueryData?.[roomType.key] == 'yes')
                                .map((roomType) => (
                                <Col xxl={4} md={6} className="mb-3" key={`${roomType.key}_range`}>
                                    <div className="afRangeGroup">
                                        <label className="afRangeLabel">{roomType.label} რაოდენობა</label>
                                        <div className="afRangePair">
                                            <input type='number' value={searchQueryData?.[`${roomType.amountKey}_from`]} onChange={(e) => handleChangeInput(e)} name={`${roomType.amountKey}_from`} placeholder={t('from')} />
                                            <span className="afRangeSep">—</span>
                                            <input type='number' value={searchQueryData?.[`${roomType.amountKey}_to`]} onChange={(e) => handleChangeInput(e)} name={`${roomType.amountKey}_to`} placeholder={t('to')} />
                                        </div>
                                    </div>
                                </Col>
                            ))}

                            <Col xxl={12} className="mb-1">
                                <label className="filterLbl">კვება</label>
                            </Col>

                            <Col xxl={4} className="mb-2">
                                <div className="rfField">
                                    <Select
                                        id="food"
                                        value={Options.eatings.filter(opt =>
                                            (searchQueryData?.food || '').includes(opt.value))}
                                        name="food"
                                        onChange={handleChangeSelect}
                                        options={Options.eatings}
                                        placeholder={t('choose_food')}
                                        className="rfReactSelect"
                                        classNamePrefix="rf-select"
                                        isMulti
                                        hideSelectedOptions={false}
                                        closeMenuOnSelect={false}
                                    />
                                </div>
                            </Col>

                            <Col xxl={12} className="addonSectionBorderBottom" />
                        </>
                        : ''}
                        

                        {/* ბიზნესცენტრის დეტალები */}
                        {searchQueryData?.property_type?.includes('businesscenter') ?
                        <>
                            <Col xxl={12} className="addonSectionBorderTop" />

                            <Col xxl={12} className="mb-2 mt-2">
                                <h4 className="filterInsSubTitle">{t('businesscenter_details')}</h4>
                            </Col>

                            <Col xxl={12} className="mb-2">
                                <label className="filterLbl">{t('businesscenter_class')}</label>
                                <div className="rfField">
                                    <Select
                                        id="businesscenterclass"
                                        value={Options.businesscenterClasses.filter(opt =>
                                            (searchQueryData?.businesscenterclass || '').includes(opt.value))}
                                        name="businesscenterclass"
                                        onChange={handleChangeSelect}
                                        options={Options.businesscenterClasses}
                                        placeholder={t('choose_class')}
                                        className="rfReactSelect"
                                        classNamePrefix="rf-select"
                                        isMulti
                                        hideSelectedOptions={false}
                                        closeMenuOnSelect={false}
                                    />
                                </div>
                            </Col>

                            <Col xxl={12} className="mb-3 mt-2">
                                <div className="customFltrLabelCheck">
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.bcseparatebuilding == 'yes'} onChange={(e) => handleChangeInput(e)} name="bcseparatebuilding" />
                                        <span className="customFilterCheckbox"></span><strong>ცალკე მთლიანი შენობა</strong>
                                    </label>
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.bcpartmentroom == 'yes'} onChange={(e) => handleChangeInput(e)} name="bcpartmentroom" />
                                        <span className="customFilterCheckbox"></span><strong>შენობის ნაწილი</strong>
                                    </label>
                                </div>
                            </Col>

                            <Col xxl={12} className="addonSectionBorderBottom" />
                        </>
                        : ''}


                        {/* მიწის დეტალები */}
                        {searchQueryData?.property_type?.includes('land') ?
                        <>
                            <Col xxl={12} className="addonSectionBorderTop" />

                            <Col xxl={12} className="mb-2 mt-2">
                                <h4 className="filterInsSubTitle">{t('land_details')}</h4>
                            </Col>

                            <Col xxl={4} className="mb-2">
                                <label className="filterLbl">{t('land_type')}</label>
                                <div className="rfField">
                                    <Select
                                        id="landtype"
                                        value={Options.landTypes.filter(opt => selectedLandTypes.includes(opt.value))}
                                        name="landtype"
                                        onChange={handleChangeSelect}
                                        options={Options.landTypes}
                                        placeholder={t('choose_type')}
                                        className="rfReactSelect"
                                        classNamePrefix="rf-select"
                                        isMulti
                                        hideSelectedOptions={false}
                                        closeMenuOnSelect={false}
                                    />
                                </div>
                            </Col>

                            {showAgriculturalLandType ?
                            <Col xxl={4} className="mb-2">
                                <label className="filterLbl">{t('sas_land_type')}</label>
                                <div className="rfField">
                                    <Select
                                        id="agriculturalland"
                                        value={Options.agriculturalTypes.filter(opt =>
                                            (searchQueryData?.agriculturalland || '').includes(opt.value))}
                                        name="agriculturalland"
                                        onChange={handleChangeSelect}
                                        options={Options.agriculturalTypes}
                                        placeholder={t('choose_type')}
                                        className="rfReactSelect"
                                        classNamePrefix="rf-select"
                                        isMulti
                                        hideSelectedOptions={false}
                                        closeMenuOnSelect={false}
                                    />
                                </div>
                            </Col>
                            : ''}

                            {showNonAgriculturalLandType ?
                            <Col xxl={4} className="mb-2">
                                <label className="filterLbl">{t('sas_land_type2')}</label>
                                <div className="rfField">
                                    <Select
                                        id="agriculturalland2"
                                        value={Options.agriculturalTypes2.filter(opt =>
                                            (searchQueryData?.agriculturalland2 || '').includes(opt.value))}
                                        name="agriculturalland2"
                                        onChange={handleChangeSelect}
                                        options={Options.agriculturalTypes2}
                                        placeholder={t('choose_type')}
                                        className="rfReactSelect"
                                        classNamePrefix="rf-select"
                                        isMulti
                                        hideSelectedOptions={false}
                                        closeMenuOnSelect={false}
                                    />
                                </div>
                            </Col>
                            : ''}

                            <Col xxl={12} className="mb-2">
                                <label className="filterLbl">{t('finctional_zone')}</label>
                                <div className="rfField">
                                    <Select
                                        id="functionalarea"
                                        value={Options.functgionZones.filter(opt =>
                                            (searchQueryData?.functionalarea || '').includes(opt.value))}
                                        name="functionalarea"
                                        onChange={handleChangeSelect}
                                        options={Options.functgionZones}
                                        placeholder={t('choose_zone')}
                                        className="rfReactSelect"
                                        classNamePrefix="rf-select"
                                        isMulti
                                        hideSelectedOptions={false}
                                        closeMenuOnSelect={false}
                                    />
                                </div>
                            </Col>

                            <Col xxl={12} className="mb-1">
                                <div className="customFltrLabelCheck">
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.building == 'yes'} onChange={(e) => handleChangeInput(e)} name="building" />
                                        <span className="customFilterCheckbox"></span><strong>{t('building_land')}</strong>
                                    </label>
                                </div>
                            </Col>

                            {searchQueryData?.building == 'yes' ?
                                renderRange('buildingarea_amount', t('building_amount'))
                            : ''}

                            {searchQueryData?.building == 'yes' ?
                            <Col xxl={4} className="mb-2">
                                <div className="afRangeGroup">
                                    <label className="afRangeLabel">{t('building_land_area')} ({t('m')}<sup>2</sup>)</label>
                                    <div className="afRangePair">
                                        <input type='number' value={searchQueryData?.buildingarea_from} onChange={(e) => handleChangeInput(e)} name='buildingarea_from' placeholder={t('from')} />
                                        <span className="afRangeSep">—</span>
                                        <input type='number' value={searchQueryData?.buildingarea_to} onChange={(e) => handleChangeInput(e)} name='buildingarea_to' placeholder={t('to')} />
                                    </div>
                                </div>
                            </Col>
                            : ''}

                            <Col xxl={12} className="mb-1">
                                <div className="customFltrLabelCheck">
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.apz == 'yes'} onChange={(e) => handleChangeInput(e)} name="apz" />
                                        <span className="customFilterCheckbox"></span><strong>APZ</strong>
                                    </label>
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.grg == 'yes'} onChange={(e) => handleChangeInput(e)} name="grg" />
                                        <span className="customFilterCheckbox"></span><strong>GRG</strong>
                                    </label>
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.agreedproject == 'yes'} onChange={(e) => handleChangeInput(e)} name="agreedproject" />
                                        <span className="customFilterCheckbox"></span><strong>{t('agreed_project')}</strong>
                                    </label>
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.buildingpermission == 'yes'} onChange={(e) => handleChangeInput(e)} name="buildingpermission" />
                                        <span className="customFilterCheckbox"></span><strong>{t('building_permission')}</strong>
                                    </label>
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.goodrelief == 'yes'} onChange={(e) => handleChangeInput(e)} name="goodrelief" />
                                        <span className="customFilterCheckbox"></span><strong>კარგი რელიეფი</strong>
                                    </label>
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.relieful_land == 'yes'} onChange={(e) => handleChangeInput(e)} name="relieful_land" />
                                        <span className="customFilterCheckbox"></span><strong>რელიეფური მიწა</strong>
                                    </label>
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.highland_status == 'yes'} onChange={(e) => handleChangeInput(e)} name="highland_status" />
                                        <span className="customFilterCheckbox"></span><strong>მაღალმთიანი მიწის სტატუსი</strong>
                                    </label>
                                </div>
                            </Col>

                            <Col xxl={12} className="addonSectionBorderBottom" />

                        </>
                        : ''}

                        
                        {/* ბიზნეს ინვესტიციის დეტალები */}
                        {searchQueryData?.property_type?.includes('business') ?
                        <>
                            <Col xxl={12} className="addonSectionBorderTop" />

                            <Col xxl={12} className="mb-2 mt-2">
                                <h4 className="filterInsSubTitle">{t('businessinvestment_details')}</h4>
                            </Col>

                            <Col xxl={4} className="mb-2">
                                <label className="filterLbl">{t('businessinvestment_category')}</label>
                                <div className="rfField">
                                    <Select
                                        id="businessinvestmentcategory"
                                        value={Options.businessIndustryes.filter(opt =>
                                            selectedBusinessCategories.includes(opt.value))}
                                        name="businessinvestmentcategory"
                                        onChange={handleChangeSelect}
                                        options={Options.businessIndustryes}
                                        placeholder={t('choose_category')}
                                        className="rfReactSelect"
                                        classNamePrefix="rf-select"
                                        isMulti
                                        hideSelectedOptions={false}
                                        closeMenuOnSelect={false}
                                    />
                                </div>
                            </Col>

                            <Col xxl={4} className="mb-2">
                                <label className="filterLbl">{t('owner')}</label>
                                <div className="rfField">
                                    <Select
                                        id="owner"
                                        value={Options.owners.find(opt => opt.value === searchQueryData?.owner) || null}
                                        name="owner"
                                        onChange={handleChangeSelect}
                                        options={Options.owners}
                                        placeholder={t('choose_owner')}
                                        className="rfReactSelect"
                                        classNamePrefix="rf-select"
                                    />
                                </div>
                            </Col>

                            <Col xxl={4} className="mb-2">
                                <label className="filterLbl">{t('owner_type')}</label>
                                <div className="rfField">
                                    <Select
                                        id="propertytype"
                                        value={Options.ownerTypes.find(opt => opt.value === searchQueryData?.propertytype) || null}
                                        name="propertytype"
                                        onChange={handleChangeSelect}
                                        options={Options.ownerTypes}
                                        placeholder={t('choose_owner_type')}
                                        className="rfReactSelect"
                                        classNamePrefix="rf-select"
                                    />
                                </div>
                            </Col>

                            <Col xxl={4} className="mb-2">
                                <label className="filterLbl">{t('actives')}</label>
                                <div className="rfField">
                                    <Select
                                        id="assets"
                                        value={Options.actives.find(opt => opt.value === searchQueryData?.assets) || null}
                                        name="assets"
                                        onChange={handleChangeSelect}
                                        options={Options.actives}
                                        placeholder={t('choose_actives')}
                                        className="rfReactSelect"
                                        classNamePrefix="rf-select"
                                    />
                                </div>
                            </Col>



                            <Col xxl={6} className="mb-2">
                                <div className="customFltrLabelCheck customFltrCstm">
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.heavyequipment == 'yes'} onChange={(e) => handleChangeInput(e)} name="heavyequipment" />
                                        <span className="customFilterCheckbox"></span><strong>{t('heavyequipment')}</strong>
                                    </label>
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.specechnique == 'yes'} onChange={(e) => handleChangeInput(e)} name="specechnique" />
                                        <span className="customFilterCheckbox"></span><strong>{t('spectechnique')}</strong>
                                    </label>
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.annualaccrual == 'yes'} onChange={(e) => handleChangeInput(e)} name="annualaccrual" />
                                        <span className="customFilterCheckbox"></span><strong>წლიური დარიცხვა</strong>
                                    </label>
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.annualnetprofit == 'yes'} onChange={(e) => handleChangeInput(e)} name="annualnetprofit" />
                                        <span className="customFilterCheckbox"></span><strong>წლიური წმინდა მოგება</strong>
                                    </label>
                                </div>
                            </Col>

                            {renderRange('numberofemployees', 'თანამშრომლების რაოდენობა', { xxl: 6 })}

                            <Col xxl={12} className="mb-3 mt-2">
                                <Row className="g-2 align-items-end">
                                    <Col xxl={4}>
                                        <div className="customFltrLabelCheck">
                                            <label className="customfltCheckbox w-100">
                                                <input type="checkbox" value="yes" checked={searchQueryData?.building1 == 'yes'} onChange={(e) => handleChangeInput(e)} name="building1" />
                                                <span className="customFilterCheckbox"></span><strong>{t('building_land')}</strong>
                                            </label>
                                        </div>
                                    </Col>

                                    {searchQueryData?.building1 == 'yes' ?
                                    <>
                                        <Col xxl={4}>
                                            <div className="afRangeGroup">
                                                <label className="afRangeLabel">{t('building_amount')}</label>
                                                <div className="afRangePair">
                                                    <input type='number' value={searchQueryData?.buildingamount1_from} onChange={(e) => handleChangeInput(e)} name='buildingamount1_from' placeholder={t('from')} />
                                                    <span className="afRangeSep">—</span>
                                                    <input type='number' value={searchQueryData?.buildingamount1_to} onChange={(e) => handleChangeInput(e)} name='buildingamount1_to' placeholder={t('to')} />
                                                </div>
                                            </div>
                                        </Col>

                                        <Col xxl={4}>
                                            <div className="afRangeGroup">
                                                <label className="afRangeLabel">{t('building_land_area')} ({t('m')}<sup>2</sup>)</label>
                                                <div className="afRangePair">
                                                    <input type='number' value={searchQueryData?.buildingarea1_from} onChange={(e) => handleChangeInput(e)} name='buildingarea1_from' placeholder={t('from')} />
                                                    <span className="afRangeSep">—</span>
                                                    <input type='number' value={searchQueryData?.buildingarea1_to} onChange={(e) => handleChangeInput(e)} name='buildingarea1_to' placeholder={t('to')} />
                                                </div>
                                            </div>
                                        </Col>
                                    </>
                                    : ''}
                                </Row>
                            </Col>

                            <Col xxl={12} className="addonSectionBorderBottom" />
                        </>
                        : ''}
                        

                        {/* ფერმის დეტალები */}
                        {searchQueryData?.property_type?.includes('farm') ?
                        <>
                            <Col xxl={12} className="addonSectionBorderTop" />

                            <Col xxl={12} className="mb-2 mt-2">
                                <h4 className="filterInsSubTitle">{t('farm_details')}</h4>
                            </Col>

                            <Col xxl={4} className="mb-2">
                                <label className="filterLbl">{t('farm_type')}</label>
                                <div className="rfField">
                                    <Select
                                        id="farmtype"
                                        value={Options.farmTypes.filter(opt =>
                                            selectedFarmTypes.includes(opt.value))}
                                        name="farmtype"
                                        onChange={handleChangeSelect}
                                        options={Options.farmTypes}
                                        placeholder={t('choose_type')}
                                        className="rfReactSelect"
                                        classNamePrefix="rf-select"
                                        isMulti
                                        hideSelectedOptions={false}
                                        closeMenuOnSelect={false}
                                    />
                                </div>
                            </Col>

                            <Col xxl={4} className="mb-2">
                                <label className="filterLbl">{t('land_type')}</label>
                                <div className="rfField">
                                    <Select
                                        id="landtype1"
                                        value={Options.farmLandTypes.filter(opt =>
                                            selectedFarmLandTypes.includes(opt.value))}
                                        name="landtype1"
                                        onChange={handleChangeSelect}
                                        options={Options.farmLandTypes}
                                        placeholder={t('choose_type')}
                                        className="rfReactSelect"
                                        classNamePrefix="rf-select"
                                        isMulti
                                        hideSelectedOptions={false}
                                        closeMenuOnSelect={false}
                                    />
                                </div>
                            </Col>

                            {showFarmAgriculturalType ?
                            <Col xxl={4} className="mb-2">
                                <label className="filterLbl">{t('sas_land_type')}</label>
                                <div className="rfField">
                                    <Select
                                        id="agrilandtype"
                                        value={Options.farmAgriculturalTypes.filter(opt =>
                                            (searchQueryData?.agrilandtype || '').includes(opt.value))}
                                        name="agrilandtype"
                                        onChange={handleChangeSelect}
                                        options={Options.farmAgriculturalTypes}
                                        placeholder={t('choose_type')}
                                        className="rfReactSelect"
                                        classNamePrefix="rf-select"
                                        isMulti
                                        hideSelectedOptions={false}
                                        closeMenuOnSelect={false}
                                    />
                                </div>
                            </Col>
                            : ''}

                            {showFarmNonAgriculturalType ?
                            <Col xxl={4} className="mb-2">
                                <label className="filterLbl">არასასოფლო სამეურნეო მიწის ტიპი</label>
                                {renderMultiSelect('nonagrilandtype', Options.farmNonAgriculturalTypes, t('choose_type'))}
                            </Col>
                            : ''}

                            <Col xxl={12} className="mb-2">
                                <Row className="g-2 align-items-end">
                                    <Col xxl={4}>
                                        <div className="customFltrLabelCheck">
                                            <label className="customfltCheckbox w-100">
                                                <input type="checkbox" value="yes" checked={searchQueryData?.buildingstructureoffice == 'yes'} onChange={(e) => handleChangeInput(e)} name="buildingstructureoffice" />
                                                <span className="customFilterCheckbox"></span><strong>{t('building_office')}</strong>
                                            </label>
                                        </div>
                                    </Col>

                                    {searchQueryData?.buildingstructureoffice == 'yes' ?
                                    <>
                                        <Col xxl={4}>
                                            <div className="afRangeGroup">
                                                <label className="afRangeLabel">{t('amount')}</label>
                                                <div className="afRangePair">
                                                    <input type='number' value={searchQueryData?.buildingstructureofficeamount_from} onChange={(e) => handleChangeInput(e)} name='buildingstructureofficeamount_from' placeholder={t('from')} />
                                                    <span className="afRangeSep">—</span>
                                                    <input type='number' value={searchQueryData?.buildingstructureofficeamount_to} onChange={(e) => handleChangeInput(e)} name='buildingstructureofficeamount_to' placeholder={t('to')} />
                                                </div>
                                            </div>
                                        </Col>

                                        <Col xxl={4}>
                                            <div className="afRangeGroup">
                                                <label className="afRangeLabel">{t('full_area')} ({t('m')}<sup>2</sup>)</label>
                                                <div className="afRangePair">
                                                    <input type='number' value={searchQueryData?.buildingstructureofficearea_from} onChange={(e) => handleChangeInput(e)} name='buildingstructureofficearea_from' placeholder={t('from')} />
                                                    <span className="afRangeSep">—</span>
                                                    <input type='number' value={searchQueryData?.buildingstructureofficearea_to} onChange={(e) => handleChangeInput(e)} name='buildingstructureofficearea_to' placeholder={t('to')} />
                                                </div>
                                            </div>
                                        </Col>
                                    </>
                                    : ''}
                                </Row>
                            </Col>

                            <Col xxl={12} className="mb-2">
                                <Row className="g-2 align-items-end">
                                    <Col xxl={4}>
                                        <div className="customFltrLabelCheck">
                                            <label className="customfltCheckbox w-100">
                                                <input type="checkbox" value="yes" checked={searchQueryData?.lake == 'yes'} onChange={(e) => handleChangeInput(e)} name="lake" />
                                                <span className="customFilterCheckbox"></span><strong>{t('lake')}</strong>
                                            </label>
                                        </div>
                                    </Col>

                                    {searchQueryData?.lake == 'yes' ?
                                    <>
                                        <Col xxl={4}>
                                            <div className="afRangeGroup">
                                                <label className="afRangeLabel">{t('amount')}</label>
                                                <div className="afRangePair">
                                                    <input type='number' value={searchQueryData?.lakeamount_from} onChange={(e) => handleChangeInput(e)} name='lakeamount_from' placeholder={t('from')} />
                                                    <span className="afRangeSep">—</span>
                                                    <input type='number' value={searchQueryData?.lakeamount_to} onChange={(e) => handleChangeInput(e)} name='lakeamount_to' placeholder={t('to')} />
                                                </div>
                                            </div>
                                        </Col>

                                        {renderRange('lakearea', <>{t('full_area')} ({t('m')}<sup>2</sup>)</>)}
                                    </>
                                    : ''}
                                </Row>
                            </Col>

                            <Col xxl={12} className="mb-2">
                                <div className="customFltrLabelCheck">
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.goodrelief == 'yes'} onChange={(e) => handleChangeInput(e)} name="goodrelief" />
                                        <span className="customFilterCheckbox"></span><strong>კარგი რელიეფი</strong>
                                    </label>
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.relieful_land == 'yes'} onChange={(e) => handleChangeInput(e)} name="relieful_land" />
                                        <span className="customFilterCheckbox"></span><strong>რელიეფური მიწა</strong>
                                    </label>
                                    <label className="customfltCheckbox">
                                        <input type="checkbox" value="yes" checked={searchQueryData?.highland_status == 'yes'} onChange={(e) => handleChangeInput(e)} name="highland_status" />
                                        <span className="customFilterCheckbox"></span><strong>მაღალმთიანი მიწის სტატუსი</strong>
                                    </label>
                                </div>
                            </Col>

                            <Col xxl={12} className="addonSectionBorderBottom" />
                        </>
                        : ''}





































                        {renderSubTitle(t('features'))}

                        <Col xxl={12} className="mb-2">
                            {renderYesCheckboxes([
                                ['duplex', t('duplex')],
                                ['triplex', t('triplex')],
                                ['quadruplex', 'ქუადპლექსი'],
                                ['beletazh', 'ბელეტაჟი'],
                            ])}
                        </Col>

                        {renderSubTitle(t('additional_advantages'))}

                        <Col xxl={12} className="mb-3">
                            {renderCheckboxGroup('additionaladvantages', additionaladvantagesOptions)}
                        </Col>

                        {renderSubTitle(t('heating'))}

                        <Col xxl={12} className="mb-3">
                            {renderCheckboxGroup('heating', heatingOptions)}
                        </Col>

                        {renderSubTitle(t('hot_water'))}

                        <Col xxl={12} className="mb-3">
                            {renderCheckboxGroup('hotwater', hotwaterOptions)}
                        </Col>

                        {renderSubTitle(t('veranda_rerrace'))}

                        <Col xxl={12} className="mb-2">
                            {renderYesCheckboxes([
                                ['openbalcony', t('open_balcony')],
                                ['closedbalcony', t('closed_balcony')],
                                ['frenchbalcony', t('frenchbalcony')],
                                ['terrace', t('veranda_rerrace')],
                                ['balconyall', 'აივანების რაოდენობა'],
                                ['closed_terrace', 'დახურული ვერანდა/ტერასა'],
                                ['glassware', 'შუშაბანდი'],
                                ['loggia', 'ლოჯი'],
                            ])}
                        </Col>

                        {renderSubTitle('სივრცე')}

                        <Col xxl={12} className="mb-3">
                            {renderYesCheckboxes([
                                ['livingroom', t('livingroom')],
                                ['studio', t('studio')],
                                ['kitchen', t('kitchen')],
                                ['inside_area', 'შიდა ფართი'],
                                ['livingroom_kitchen', 'მისაღები + სასადილო ოთახი'],
                                ['kitchen_dining', 'სამზარეულო + სასადილო ოთახი'],
                                ['dining_room', 'სასადილო ოთახი'],
                                ['cabinet', 'კაბინეტის ოთახი'],
                                ['childrenroom', 'საბავშვო ოთახი'],
                                ['dressingroom', 'საგარდერობო ოთახი'],
                                ['storage', 'სათავსო'],
                                ['summerkitchen', 'საზაფხულო სამზარეულო'],
                                ['fireplaceroom', 'ბუხრის ოთახი'],
                                ['partyroom', 'საქეიფო ოთახი'],
                                ['technical_room', 'ტექნიკური ოთახი'],
                                ['laundry_room', 'სამრეცხაო ოთახი'],
                                ['wineroom', 'მარანის ოთახი'],
                                ['refrigerator_room', 'სამაცივრე ოთახი'],
                                ['gym_room', 'ტრენაჟორების ოთახი'],
                                ['billiard_room', 'საბილიარდო ოთახი'],
                                ['cinema_room', 'კინოს ოთახი'],
                                ['basement', 'სარდაფი'],
                                ['hall', 'ჰოლი'],
                                ['loft', 'სხვენი'],
                                ['mansarda', 'მანსარდა'],
                                ['buildup', 'დაშენება'],
                                ['buildup1', 'მიშენება'],
                                ['commoncorridor', 'საერთო კორიდორი'],
                                ['antresor', 'ანტრესორი'],
                                ['wintergarden', 'ზამთრის ბაღი'],
                                ['house_amount', 'სახლის რაოდენობა'],
                                ['aux_building', 'დამხმარე შენობა'],
                                ['yeard', 'იზოლირებული ეზო'],
                                ['common_yard', 'საერთო ეზო'],
                                ['common_kitchen', 'საერთო სამზარეულო'],
                                ['common_storage', 'საერთო სათავსო'],
                                ['common_terrace', 'საერთო ტერასა'],
                                ['common_attic', 'საერთო სხვენი'],
                                ['outdoor_wc', 'გარე სველი წერტილი'],
                                ['isolated', 'იზოლირებული სველი წერტილი'],
                            ])}
                        </Col>

                        {renderSubTitle('დამატებითი პარამეტრები')}

                        <Col xxl={12} className="mb-3">
                            {renderYesCheckboxes([
                                ['elevator_all', 'ლიფტების რაოდენობა'],
                                ['elevator', 'სამგზავრო ლიფტი'],
                                ['freightelevator', 'სატვირთო ლიფტი'],
                                ['personalelevator', 'პერსონალური ლიფტი'],
                                ['openpool', 'ღია აუზი'],
                                ['Indoorpool', 'დახურული აუზი'],
                                ['fireplace', 'ბუხარი'],
                            ])}
                        </Col>

                        {renderSubTitle('კომუნიკაციები')}

                        <Col xxl={12} className="mb-3">
                            {renderCheckboxGroup('communications', communicationsOptions)}
                        </Col>

                        {renderSubTitle('ზოგადი დეტალები')}

                        <Col xxl={12} className="mb-3">
                            {renderCheckboxGroup('additionaldetails', additionaldetailsOptions)}
                        </Col>

                        {renderSubTitle('გზა')}

                        <Col xxl={12} className="mb-3">
                            {renderCheckboxGroup('road', roadOptions)}
                        </Col>

                        {renderSubTitle('ზოგადი კეთილმოწყობა')}

                        <Col xxl={12} className="mb-3">
                            {renderCheckboxGroup('generalamenities', generalamenitiesOptions)}
                        </Col>

                        {renderSubTitle('ავეჯი')}

                        <Col xxl={12} className="mb-3">
                            {renderCheckboxGroup('furniture', furnitureOptions)}
                        </Col>

                        {renderSubTitle('ტექნიკა')}

                        <Col xxl={12} className="mb-3">
                            {renderCheckboxGroup('technic', technicOptions)}
                        </Col>

                        {renderSubTitle('დაცვის სერვისი')}

                        <Col xxl={12} className="mb-3">
                            {renderCheckboxGroup('security', securityOptions)}
                        </Col>

                        {renderSubTitle('ჭკვიანი სახლი')}

                        <Col xxl={12} className="mb-3">
                            {renderCheckboxGroup('smarthouse', smarthouseOptions)}
                        </Col>

                        {renderSubTitle('დამატებითი უსაფრთხოება')}

                        <Col xxl={12} className="mb-3">
                            {renderCheckboxGroup('additionalsecurity', additionalsecurityOptions)}
                        </Col>

                        {renderSubTitle('დაშვებულია')}

                        <Col xxl={12} className="mb-3">
                            {renderCheckboxGroup('allowed', allowedOptions)}
                        </Col>

                        {renderSubTitle(t('building_material'))}

                        <Col xxl={12} className="mb-3">
                            {renderCheckboxGroup('buildingmaterial', buildingmaterialOptions)}
                        </Col>

                        {renderSubTitle('კარ-ფანჯრის ტიპი-მასალა')}

                        <Col xxl={12} className="mb-3">
                            {renderCheckboxGroup('doorandwindow', doorandwindowOptions)}
                        </Col>

                        {renderSubTitle('ფასადი')}

                        <Col xxl={12} className="mb-3">
                            {renderCheckboxGroup('facade1', facade1Options)}
                        </Col>

                        {renderSubTitle('გადახურვის ტიპი')}

                        <Col xxl={12} className="mb-3">
                            {renderCheckboxGroup('overlap', overlapOptions)}
                        </Col>

                        {renderSubTitle('გადახურვის მასალა')}

                        <Col xxl={12} className="mb-3">
                            {renderCheckboxGroup('overlapmaterial', overlapmaterialOptions)}
                        </Col>

                        {renderSubTitle('ფუნდამენტის ტიპი')}

                        <Col xxl={12} className="mb-3">
                            {renderCheckboxGroup('fundament', fundamentOptions)}
                        </Col>

                        {renderSubTitle('ობიექტთან ახლოს')}

                        <Col xxl={12} className="mb-3">
                            {renderYesCheckboxes([
                                ['metrosstation', 'მეტროსადგური'],
                                ['citycenter', 'ქალაქის ცენტრი'],
                                ['busstop', 'ავტობუსის გაჩერება'],
                                ['shoppingcenter', 'სავაჭრო ცენტრი'],
                                ['school', 'სკოლა'],
                                ['kindergarten', 'საბავშვო ბაღი'],
                                ['cinema', 'კინოთეატრი'],
                                ['square', 'სკვერი'],
                                ['museum', 'მუზეუმი'],
                                ['restaurant', 'რესტორანი'],
                                ['supermarket', 'სუპერმარკეტი'],
                                ['pharmacy', 'აფთიაქი'],
                                ['hospital', 'საავადმყოფო'],
                                ['railwaystation', 'რკინიგზის სადგური'],
                                ['airport', 'აეროპორტი'],
                                ['sea', 'ზღვა'],
                                ['river', 'მდინარე'],
                                ['lake1', 'ტბა'],
                                ['naturereserve', 'ნაკრძალი'],
                                ['forest', 'ტყე'],
                                ['university', 'უნივერსიტეტი'],
                                ['sportstadium', 'სპორტული მოედანი'],
                                ['bank', 'ბანკი'],
                                ['sportgym', 'სპორტული დარბაზი'],
                                ['boulvar', 'ბულვარი'],
                                ['fastfood', 'სწრაფი კვება'],
                                ['currencyexchange', 'ვალუტის ჯიხური'],
                                ['nightclub', 'ღამის კლუბი'],
                                ['cafe_bar', 'კაფე-ბარი'],
                                ['mountain', 'მთა'],
                                ['canyon', 'კანიონი'],
                                ['waterfall', 'ჩანჩქერი'],
                                ['botanic', 'ბოტანიკური ბაღი'],
                                ['zoo', 'ზოოპარკი'],
                                ['funicular', 'ფუნიკულიორი'],
                                ['stadium', 'სტადიონი'],
                                ['concert_hall', 'საკონცერტო დარბაზი'],
                                ['clinic', 'კლინიკა'],
                                ['port', 'პორტი'],
                                ['aquapark', 'აკვაპარკი'],
                                ['bath', 'აბანო'],
                                ['entertainment_center', 'გასართობი ცენტრი'],
                                ['church_monastery', 'ეკლესია მონასტერი'],
                                ['fortress', 'ციხე-სიმაგრე'],
                                ['house_museum', 'სახლ-მუზეუმი'],
                                ['dendrological_park', 'დენდროლოგიური პარკი'],
                            ])}
                        </Col>

                        {selectedTransactions.includes('dailyrent') ?
                        <>
                            {renderSubTitle('დღიურად გაქირავება')}
                            <Col xxl={4} className="mb-2">
                                <div className="form-group filterFormGroupInput">
                                    <label htmlFor='adult'>ზრდასრულების რაოდენობა</label>
                                    <input type='number' id='adult' value={searchQueryData?.adult ?? ''} onChange={(e) => handleChangeInput(e)} name='adult' placeholder='ზრდასრული' />
                                </div>
                            </Col>
                            <Col xxl={4} className="mb-2">
                                <div className="form-group filterFormGroupInput">
                                    <label htmlFor='children'>ბავშვების რაოდენობა</label>
                                    <input type='number' id='children' value={searchQueryData?.children ?? ''} onChange={(e) => handleChangeInput(e)} name='children' placeholder='ბავშვი' />
                                </div>
                            </Col>
                        </>
                        : ''}

                    </Row>

                </div>

                <div className="addonFilterBottom">
                    <button onClick={() => setFilterModal(false)} className="erasePropertyButton">{t('close')}</button>
                    <button type="button" className="searchPropertyButton" onClick={() => filter()}><FontAwesomeIcon icon={faMagnifyingGlass} /> {t('search')}</button>
                </div>

            </div>
        </>
    );
}
